import React from 'react';
import { Link } from 'react-router-dom';
import { PackageSearch } from 'lucide-react';
import { btnMd, btnPrimary } from '../styles/ui';

const EmptyState = ({ icon: Icon = PackageSearch, title, description, action }) => (
  <div className="text-center py-16 max-w-md mx-auto">
    <div className="w-16 h-16 bg-emerald-50 rounded-2xl flex items-center justify-center mx-auto mb-4 shadow-soft">
      <Icon className="text-emerald-700" size={28} aria-hidden="true" />
    </div>
    <h3 className="serif text-2xl text-emerald-950 mb-2">{title}</h3>
    {description && <p className="text-ink-secondary mb-6">{description}</p>}
    {action && action.to && (
      <Link
        to={action.to}
        className={`${btnPrimary} ${btnMd}`}
      >
        {action.label}
      </Link>
    )}
    {action && action.onClick && (
      <button
        type="button"
        onClick={action.onClick}
        className={`${btnPrimary} ${btnMd}`}
      >
        {action.label}
      </button>
    )}
  </div>
);

export default EmptyState;
